<table class="table">
  <thead>
    <tr>
      <th>For</th>
      <th>Action</th>
      <th>Date</th>
      <th>User</th>
    </tr>
  </thead>
  <tbody>
    @for (item of audit; track item) {
      <tr>
        @if (item.bTitle) {
          <td>
            <span title="Building #{{ item.bId }}"><i class="mdi mdi-office-building-outline"></i></span>
            {{ item.bTitle }}
          </td>
        }
        @if (item.gTitle) {
          <td>
            <span title="Gateway #{{ item.gId }}"><i class="mdi mdi-router-wireless"></i></span>
            {{ item.gTitle }}
          </td>
        }
        <td>{{ item.action }}</td>
        <td>{{ item.createdAt | amDateFormat: 'DD MMM YYYY HH:mm:ss' }}</td>
        <td>{{ item.uName }}</td>
      </tr>
    }
  </tbody>
</table>
